<div class="complaint-subscription__header row" id="complaintSubscriptionHeader">
  <div class="complaint-subscription__header-col col-12">
    <h3 class="complaint-subscription__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('complaint_intro')"
        [innerHTML]="translationService.getTranslation('complaint_intro')"></h3>
  </div>
  <div class="complaint-subscription__header-col col-12">
    <p class="complaint-subscription__description"
        [innerHTML]="translationService.getTranslation('complaint_description')"></p>
  </div>
</div>
<div class="complaint-subscription__content row">
  <div class="complaint-subscription__errors col-12 complaintSubscriptionErrors">
    <app-general-errors [errors]="errorsArr"></app-general-errors>
    @if (isLoadingSub || isLoadingComp()) {
      <div class="complaint-subscription__spinner" style="text-align: center;" id="complaintSubscriptionSpinner">
        <app-loading-spinner/>
      </div>
    }
    @if (!isLoadingSub && !isLoadingComp() && subs.length == 0 && errorsArr.length == 0) {
      <div class="complaint-subscription__no-subs"
           [innerHTML]="translationService.getTranslation('intro_noSubs')">
      </div>
    }
    <div class="row complaint-subscription__subs" id="complaintSubscriptions">
      @if (!isLoadingComp() && !isLoadingSub && subs.length > 0) {
        @for (sub of subs; track sub; let i = $index) {
          <div class="col-12 col-md-6 col-lg-4 mt-4">
            <mat-card class=" complaint-subscription__sub-card" appearance="outlined">
              <div class="complaint-subscription__sub-row m-3">
                <div tabindex="0" class="complaint-subscription__sub-info col-12">
                  <mat-card-title class="complaint-subscription__sub-title">{{ sub.productDescription }}</mat-card-title>
                  @if (sub.subId) {
                    <mat-card-subtitle class="complaint-subscription__sub-id"
                                       [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId">
                    </mat-card-subtitle>
                  }
                  @if (sub.variantDescription) {
                    <mat-card-subtitle class="complaint-subscription__sub-edition"
                                       [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription">
                    </mat-card-subtitle>
                  }
                  @if (sub.validDate) {
                    <mat-card-subtitle class="complaint-subscription__sub-period"
                                       [innerHTML]="translationService.getTranslation('period') +': ' +
                        (sub.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
                        ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))">
                    </mat-card-subtitle>
                  }
                  @if (sub.curDelivery) {
                    <mat-card-subtitle class="complaint-subscription__sub-address">
                      {{ sub.curDelivery.person.addressCodeDescription }}
                      {{ sub.curDelivery.person.firstname }}
                      {{ sub.curDelivery.person.lastname }},
                      {{ sub.curDelivery.address.city }},
                      {{ sub.curDelivery.address.street }} {{ sub.curDelivery.address.houseno | houseNoPipe }}
                    </mat-card-subtitle>
                  }
                </div>
                <div class="complaint-subscription__sub-actions col-12">
                  <mat-card-actions class="complaint-subscription__actions card-actions">
                    <button ngSkipHydration mat-raised-button color="primary"
                            class="mt-2 complaint-subscription__new-complaint-btn"
                            [disabled]="!isComplainable(sub)"
                            (click)="onNewComplaint(sub)">
                      {{ translationService.getTranslation('button_new_complaint') }}
                    </button>
                  </mat-card-actions>
                  @if (!isComplainable(sub)) {
                    <p class="complaint-subscription__warning text-warning text-end" id="complaint-warning"
                       [innerHTML]="translationService.getTranslation('complaint_impossible')"></p>
                  }
                </div>
              </div>
              @if (complaintsGrouped && complaintsGrouped.length > 0) {
                <mat-card-content class="complaint-subscription__complaints">
                  <mat-accordion class="complaint-subscription__accordion" multi>
                    @for (complaintGroup of complaintsGrouped; track complaintGroup; let innerI = $index) {
                      <mat-expansion-panel class="complaint-subscription__expansion-panel">
                        @if (complaintGroup[0].subId === sub.backendId) {
                          <mat-expansion-panel-header class="complaint-subscription__expansion-header"
                                                      [collapsedHeight]="'calc(100%)'" [expandedHeight]="'100%'">
                            @if (complaintGroup[0].reasonBaseData?.description) {
                              <mat-panel-title class="complaint-subscription__complaint-title complaintTitle">
                                {{ complaintGroup[0].reasonBaseData?.description }}
                              </mat-panel-title>
                            } @else {
                              <mat-panel-title class="complaint-subscription__complaint-title complaintTitle"
                                               [innerHTML]="translationService.getTranslation('complaint_reason_placeholder')">
                              </mat-panel-title>
                            }
                            <mat-panel-description class="complaint-subscription__complaint-description">
                              <ul class="complaint-subscription__complaint-list"
                                  style="margin-top: 1rem; margin-bottom: 1rem">
                                @for (complaint of complaintGroup; track complaint) {
                                  <li class="complaint-subscription__complaint-list-item">
                                    {{ complaint.validDate.validFrom | date: translationService.getTranslation('dateFormat') }}
                                  </li>
                                }
                              </ul>
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                        }
                        <ng-template matExpansionPanelContent>
                          @if (complaintGroup[0].compensations && complaintGroup[0].compensations.length > 0) {
                            <div class="complaint-subscription__compensations row">
                              <div class="complaint-subscription__compensations-label col-6"
                                   [innerHTML]="translationService.getTranslation('complaint_compensation')"></div>
                              <div class="complaint-subscription__compensations-list col-6">
                                @for (compensation of complaintGroup[0].compensations; track compensation) {
                                  <div class="complaint-subscription__compensation">
                                    {{ compensation.description }}
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          @if (complaintGroup[0].memo.memoText && complaintGroup[0].memo.memoText !== "") {
                            <div class="complaint-subscription__memo row">
                              <div class="complaint-subscription__memo-label col-6"
                                   [innerHTML]="translationService.getTranslation('complaint_reasonMemo')"></div>
                              <div class="complaint-subscription__memo-text col-6">
                                {{ complaintGroup[0].memo.memoText }}
                              </div>
                            </div>
                          }
                        </ng-template>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </mat-card-content>
              }
            </mat-card>
          </div>
        }
      }
    </div>
  </div>
</div>

<ng-template #placeholder>
  <mat-panel-title class="complaint-subscription__complaint-title complaintTitle"
                   [innerHTML]="translationService.getTranslation('complaint_reason_placeholder')"></mat-panel-title>
</ng-template>
